import { Grid, Typography } from "@material-ui/core"; //FB 6163
import React, { useState, useEffect, useRef } from "react";

// update log
// FB 6036 MS   05/17/2022    Created
// FB 6163 DK   09/21/2022    UI changes on video call

const Participant = (props) => {
  const participant = props.participant;
  const [videoTracks, setVideoTracks] = useState([]);
  const [audioTracks, setAudioTracks] = useState([]);

  const videoRef = useRef();
  const audioRef = useRef();

  const trackpubsToTracks = (trackMap) =>
    Array.from(trackMap.values())
      .map((publication) => publication.track)
      .filter((track) => track !== null);

  useEffect(() => {
    setVideoTracks(trackpubsToTracks(participant.videoTracks));
    setAudioTracks(trackpubsToTracks(participant.audioTracks));

    const trackSubscribed = (track) => {
      if (track.kind === "video") {
        setVideoTracks((videoTracks) => [...videoTracks, track]);
      } else if (track.kind === "audio") {
        setAudioTracks((audioTracks) => [...audioTracks, track]);
      }
    };

    const trackUnsubscribed = (track) => {
      if (track.kind === "video") {
        setVideoTracks((videoTracks) => videoTracks.filter((v) => v !== track));
      } else if (track.kind === "audio") {
        setAudioTracks((audioTracks) => audioTracks.filter((a) => a !== track));
      }
    };

    participant.on("trackSubscribed", trackSubscribed);
    participant.on("trackUnsubscribed", trackUnsubscribed);

    return () => {
      setVideoTracks([]);
      setAudioTracks([]);
      participant.removeAllListeners();
    };
  }, [participant]);

  useEffect(() => {
    const videoTrack = videoTracks[0];
    if (videoTrack) {
      videoTrack.attach(videoRef.current);
      return () => {
        videoTrack.detach();
      };
    }
  }, [videoTracks]);

  useEffect(() => {
    const audioTrack = audioTracks[0];
    if (audioTrack) {
      audioTrack.attach(audioRef.current);
      return () => {
        audioTrack.detach();
      };
    }
  }, [audioTracks]);

  return (
    // FB 6163 - Start
    <Grid container direction="column">
      <Grid item>
        <Typography variant="h6" style={{ color: "white", textTransform: "capitalize", textAlign: "center" }}>{participant.identity}</Typography>
      </Grid>
      <Grid item>
        <video style={props.type == "self" ? { maxHeight: 200, maxWidth: 200 } : {}} ref={videoRef} autoPlay={true} />
        <audio ref={audioRef} autoPlay={true} />
      </Grid>
    </Grid>
    // FB 6163 - End
  );
};

export default Participant;
